import { i18n } from 'localization'
import { Laterality } from 'utils/enums'

export const booleanOptions = [
	{
		value: true,
		text: i18n`Yes`,
	},
	{
		value: false,
		text: i18n`No`,
	},
]

export const booleanWithNoInfoOptions = [
	{
		value: true,
		text: i18n`Yes`,
	},
	{
		value: false,
		text: i18n`No`,
	},
	{
		value: 'no_info',
		text: i18n`No information`,
	},
]

export const booleanSuccessfulContactOptions = [
	{
		value: '1',
		text: i18n`Yes`,
	},
	{
		value: '4',
		text: i18n`No`,
	},
]

export const motiveOptions = [
	{
		value: 1,
		text: i18n`Road accident`,
	},
	{
		value: 2,
		text: i18n`Personal accident`,
	},
	{
		value: 3,
		text: i18n`Civil responsibility`,
	},
	{
		value: 4,
		text: i18n`Other`,
	},
]

export const validationOptions = [
	{
		value: true,
		text: i18n`Yes`,
	},
	{
		value: false,
		text: i18n`Doesn't match`,
	},
]

export const accidentSites = [
	{
		value: 1,
		text: i18n`At workplace`,
	},
	{
		value: 2,
		text: i18n`In Service (Outside)`,
	},
	{
		value: 3,
		text: i18n`On way home or vice versa`,
	},
]

export const sportsAccidentSites = [
	{
		value: 1,
		text: i18n`In training`,
	},
	{
		value: 2,
		text: i18n`In game`,
	},
	{
		value: 3,
		text: i18n`Other`,
	},
]

export const trustNetworkFollowingReasons = [
	{
		value: 1,
		text: i18n`Not in need of assistance`,
	},
	{
		value: 2,
		text: i18n`Treatment outside network`,
	},
	{
		value: 4,
		text: i18n`Hospitalization`,
	},
]

export const lateralityOptions = [
	{ value: Laterality.Left, text: 'Esq' },
	{ value: Laterality.Right, text: 'Dir' },
	{ value: Laterality.NotApplicable, text: 'NA' },
]

export const numericLateralityOptions = [
	{ value: '1', text: 'Esq' },
	{ value: '2', text: 'Dir' },
	{ value: '3', text: 'NA' },
	{ value: '4', text: 'Ambos' },
]

export const extendedLateralityOptions = [
	{ value: '1', text: i18n`Left` },
	{ value: '2', text: i18n`Right` },
	{ value: '3', text: i18n`Not applicable` },
]

export const hospitalizedReasonOptions = [
	{ value: 1, text: i18n`Surgery` },
	{ value: 2, text: i18n`Blood Transfusion` },
	{ value: 3, text: i18n`Hospital Infection` },
	{ value: 4, text: i18n`Other` },
]

export const onSickLeaveEntities = [
	{ value: 1, text: `SNS` },
	{ value: 2, text: i18n`Private` },
]
